App.controller('ResponseFreeResponseListCtrl', ResponseFreeResponseListCtrl);

ResponseFreeResponseListCtrl.$inject = [
    '$routeParams',
    'DialogService',
    'responseFactory',
    'answers'
];

function ResponseFreeResponseListCtrl($routeParams, DialogService, responseFactory, answers) {
    var vm = this;

    vm.answers = answers;
    vm.code = $routeParams.code;

    vm.update = update;

    function update(answer) {
        responseFactory.updateAnswer($routeParams.code, answer).then(function() {
            DialogService.success('The answer has been successfully updated');

            setTimeout(function() {
                DialogService.close(); /* hack solution */
            }, 3000);
        });
    }
}